// 対象フォーム要素（input[type=text]やtextarea）にフォーカス時に中身の文章を全選択する機能
// スマートフォンでは`on "focus"`が発火しないので、`on "click"`での対応としている
$(() => {
  $('.js-focus-select').on('click', e => {
    $(e.currentTarget).select();
  });
});
